/**
 * エラー画面（404エラー）
 */

/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { ErrorParts } from "screens/Error";

const ErrorNotFound = memo(() => {
  return <ErrorParts errorCode={404}></ErrorParts>;
});

export default ErrorNotFound;
